import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { fetchNewCourses } from '../../../actions/course.actions';
import useAction from '../../../utils/useAction';
import { getNewCourses, getNewCoursesStatus } from '../../../reducers/dashboard.selectors';
import { AsyncActionStatus } from '../../../actions/common.actionTypes';
import NewCarousel from '../../../components/Carousel/NewCarousel';
import useRouter from '../../../utils/useRouter';
import { numberOfSlides, routes } from '../../../constants';
import { CourseMindItemSearchResult } from '@klab-berlin/api-sdk/lib/types/responses/MindItem';
import DashboardMuiCard from '../../cards/MuiCard/DashboardMuiCard';
import CardSkeleton from '../../Carousel/CardSkeleton';
import { getCourseMuiCardProps } from '../../cards/MuiCard/CourseMuiCard/utils';

const CoursesCarousel: React.FC = () => {
  const { t } = useTranslation();
  const { router } = useRouter();
  const fetchNewCoursesAction = useAction(fetchNewCourses);
  const newCourses = useSelector((state) => getNewCourses(state));
  const newCoursesStatus = useSelector((state) => getNewCoursesStatus(state));
  const slides = new Array(numberOfSlides.xl).fill(null);

  useEffect(() => {
    fetchNewCoursesAction();
  }, []);

  return (
    <NewCarousel 
      title={t('New in the course catalog')}
      slidesCount={newCourses.length}
      onShowAll={() => router.push(`/${routes.courseCatalog.root}`)}
    >
      {newCoursesStatus === AsyncActionStatus.READY ? (
        newCourses.map((course: CourseMindItemSearchResult, index: number) => (
          <DashboardMuiCard
            key={index}
            {...getCourseMuiCardProps(course)}
          />
        ))
      ) : slides.map((_, index) => <CardSkeleton key={index} />)}
    </NewCarousel>

  );
};

export default React.memo(CoursesCarousel);
